import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=ea4284f8&scoped=true"
import script from "./Automation.vue?vue&type=script&lang=js"
export * from "./Automation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4284f8",
  null
  
)

export default component.exports